import React from "react"
import propTypes from "prop-types"
import ReactTooltip from "react-tooltip"
import "./styles.scss"
import icon from "./images/icon-question.svg"

const Tooltip = ({ children, place, type, effect }) => {
  return (
    <div className="tooltip">
      <a href="/#" className="tooltip_btn" data-tip="React-tooltip">
        <span className="tooltip_btn_text">Need Help</span>

        <img className="tooltip_btn_img" src={icon} alt="Need Help" />
      </a>

      <ReactTooltip
        className="tooltip_container"
        place={place}
        type={type}
        effect={effect}
      >
        {children}
      </ReactTooltip>
    </div>
  )
}

Tooltip.defaultProps = {
  place: "left",
  type: "dark",
  effect: "solid"
}

Tooltip.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  place: propTypes.string,
  type: propTypes.string,
  effect: propTypes.string
}

export default Tooltip
